import { Component } from '@angular/core';
import { MatLegacyDialog } from '@angular/material/legacy-dialog';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';

import { ReceivingReportUnifiedFormComponent } from 'v2/modules/receiving-report/components/receiving-report-unified-form/receiving-report-unified-form.component';
import { DialogConfig } from 'v2/modules/shared/configs/dialog.config';

import { ECostLayerChangeTransactionType } from '../../cost-layers.const';
import {
  ICostLayerChange,
  ICostLayerChangesAgCellParams,
} from '../../cost-layers.types';

@Component({
  selector: 'lum-cost-layer-changes-ag-cell-transaction',
  templateUrl: './cost-layer-changes-ag-cell-transaction.component.html',
  styleUrls: ['./cost-layer-changes-ag-cell-transaction.component.scss'],
})
export class CostLayerChangesAgCellTransactionComponent
  implements ICellRendererAngularComp
{
  #params :ICostLayerChangesAgCellParams;

  readonly ECostLayerChangeTransactionType = ECostLayerChangeTransactionType;
  readonly HumanTitleByTransactionType :Record<
    ECostLayerChangeTransactionType,
    string
  > = {
    [ECostLayerChangeTransactionType.ADJUSTMENT]: 'Adjustment Entry',
    [ECostLayerChangeTransactionType.ASSEMBLY_ORDER]: 'Assembly Order',
    [ECostLayerChangeTransactionType.DISASSEMBLY_ORDER]: 'Disassembly Order',
    [ECostLayerChangeTransactionType.IMPORT]: 'Import',
    [ECostLayerChangeTransactionType.MANUAL]: 'Manual Edit',
    [ECostLayerChangeTransactionType.PICKLIST]: 'Picklist',
    [ECostLayerChangeTransactionType.RECEIPT]: 'Receipt',
    [ECostLayerChangeTransactionType.SALES_ORDER]: 'Sales Order',
    [ECostLayerChangeTransactionType.STOCK_PULL]: 'Stock Pull',
  };

  change :ICostLayerChange;
  didInit :boolean = false;
  showingTransactionDetails :boolean = false;

  constructor(private _legacyDialog :MatLegacyDialog) {}

  agInit(params :ICostLayerChangesAgCellParams) {
    this.#params = params;
    this.change = params?.data;
    this.didInit = true;
  }

  refresh(params :ICostLayerChangesAgCellParams) :boolean {
    this.#params = {
      ...this.#params,
      ...params,
    };

    return true;
  }

  handleClickReceipt(e :PointerEvent) {
    e.preventDefault();

    this._legacyDialog.open(ReceivingReportUnifiedFormComponent, {
      ...DialogConfig.XX_LARGE,
      data: { id: this.change.transaction.id },
    });
  }

  handleToggleData(e :Event, type ?:'unknown' | 'noTransaction') {
    this.#toggleTransactionDetails();
  }

  #toggleTransactionDetails(toState ?:boolean) {
    toState = toState ?? !this.showingTransactionDetails;

    this.showingTransactionDetails = toState;
  }
}
